import App from './App.svelte';
import CatApp from './CatApp.svelte';

const app = new CatApp({
	target: document.body,
	props: {
		name: `word ${new Date().toLocaleTimeString()}`,
	}
});

export default app;
